import {Component, HostListener, Input, OnInit} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {IndexServiceDialogComponent} from '../index-service-dialog/index-service-dialog.component';

@Component({
  selector: 'app-index-service-card',
  templateUrl: './index-service-card.component.html',
  styleUrls: ['./index-service-card.component.scss']
})
export class IndexServiceCardComponent implements OnInit {
  @Input() data;
  showMore:boolean = false;
  screenWidth: number;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.screenWidth = window.innerWidth;
    if(this.screenWidth <= 1024) {
      this.showMore = true;
    }else {
      this.showMore = false;
    }
  }
  constructor(
    private dialog: MatDialog,
    public _translate: TranslateService,
  ) {

    this.screenWidth = window.innerWidth;
    if(this.screenWidth <= 1024) {
      this.showMore = true;
    }else {
      this.showMore = false;
    }
  }

  ngOnInit(): void {
  }

  openMore() {
    this.dialog.open(IndexServiceDialogComponent,
      {
        data: this.data,
      });
  }
}
